import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { Title } from '@angular/platform-browser';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FormlyModule } from '@ngx-formly/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';

import { CoreModule } from '@core/core.module';
import { SharedModule } from './app/shared/shared.module';
import { AccountManagementModule } from '@module/account-management/account-management.module';

import { CustomTranslateLoader } from '@core/services/translation-loader.service';

import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { TokenInterceptor } from '@core/interceptors/token.interceptor';
import { PublicViewInterceptor } from '@core/interceptors/public-view.interceptor';
import { LoaderInterceptor } from '@core/interceptors/loader.interceptor';

import { NotificationsService } from './app/shared/services/notifications.service';
import { AppInjector } from './app/shared/services/app-injector.service';
import { environment } from './environments/environment';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),


    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),

    NotificationsService,
    Title,

    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PublicViewInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),

    importProvidersFrom(
      AppRoutingModule,
      CoreModule,
      SharedModule,
      AccountManagementModule,
      BrowserModule,

      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader,
          deps: [HttpClient]
        }
      }),

      FormlyModule.forRoot(),
      NgIdleKeepaliveModule.forRoot()
    )
  ]
})
  .then(appRef => {
    AppInjector.setInjector(appRef.injector);
  })
  .catch(err => { throw err; });
